import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledPricingFeaturesSection } from "./pricing-features-section.scss";
import FeatureComponent from "./components/feature-component/feature-component";
import DefaultProps from "./default-props";
class PricingFeaturesSection extends PureComponent {
    render() {
        const { section, translate, plans, sectionHeaderID } = this.props;
        return /*#__PURE__*/ _jsxs(StyledPricingFeaturesSection, {
            className: "pricing-features-section",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "header",
                    role: "row",
                    tabIndex: 0,
                    children: /*#__PURE__*/ _jsx("h3", {
                        className: "section-name",
                        role: "rowheader",
                        id: sectionHeaderID,
                        children: translate(section.sectionName)
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "features-list",
                    role: "rowgroup",
                    "aria-labelledby": sectionHeaderID,
                    children: section.features.map((feature, index)=>{
                        const { name, description, id, onVisible } = feature;
                        return /*#__PURE__*/ _jsx("div", {
                            className: "feature",
                            role: "row",
                            children: /*#__PURE__*/ _jsx(FeatureComponent, {
                                plans: plans,
                                featureName: name,
                                featureDescription: description,
                                featureValuesPerPlan: feature.tiers,
                                onVisible: onVisible,
                                featureId: id,
                                indexInSection: index,
                                sectionName: section.sectionName
                            }, name)
                        }, name);
                    })
                })
            ]
        });
    }
}
export default withGenericConfig(PricingFeaturesSection);
PricingFeaturesSection.defaultProps = DefaultProps;
